import React from 'react'
import Marquee from "react-fast-marquee";

export const Partners = () => {
    return (
        // This is the partners section
        <div className='bg-blue-500 flex flex-col justify-center items-center p-10 gap-5 w-full text-white'>
            {/* // This is the title */}
            <h2 className='text-2xl font-semibold'>Clinqo is trusted by Leading Partners</h2>

            {/* // This is the marquee (Moving Section) */}
            <Marquee className='w-full' direction="left" speed={65}>
                <div className='flex mx-8 flex-wrap gap-8 w-full'>
                    {/* // These are the partner brands */}
                    <div className=' px-8 py-4 bg-white rounded-lg'>

                    </div>
                    <div className='px-8 py-4 bg-white rounded-lg'>

                    </div>
                    <div className='px-8 py-4 bg-white rounded-lg'>

                    </div>
                    <div className='px-8 py-4 bg-white rounded-lg'>

                    </div>
                    <div className='px-8 py-4 bg-white rounded-lg'>

                    </div>
                    <div className='px-8 py-4 bg-white rounded-lg'>

                    </div>
                </div>
            </Marquee>
        </div>
    )
}
